module.exports = __webpack_public_path__ + "media/images/page/top/mv2-c34f59abb0070384fccf437ae1ae3189.png";